import * as block0 from './blocks/0.json';
import * as block1 from './blocks/1.json';
import * as block2 from './blocks/2.json';
import * as block3 from './blocks/3.json';
import * as block4 from './blocks/4.json';
import * as block5 from './blocks/5.json';
import * as block6 from './blocks/6.json';
import * as block7 from './blocks/7.json';
import * as block9 from './blocks/9.json';
import * as block11 from './blocks/11.json';
import * as block12 from './blocks/12.json';
import * as block13 from './blocks/13.json';
import * as block15 from './blocks/15.json';
import * as block17 from './blocks/17.json';
import * as block18 from './blocks/18.json';
import * as block19 from './blocks/19.json';
import * as block21 from './blocks/21.json';
import * as block24 from './blocks/24.json';
import * as block25 from './blocks/25.json';
import * as block26 from './blocks/26.json';
import * as block27 from './blocks/27.json';
import * as block28 from './blocks/28.json';
import * as block29 from './blocks/29.json';
import * as block30 from './blocks/30.json';
import * as block31 from './blocks/31.json';
import * as block32 from './blocks/32.json';

export const textBlocks = [
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/0.png`,
    content: block0,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/1.png`,
    content: block1,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/2.png`,
    content: block2,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/3.png`,
    content: block3,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/4.png`,
    content: block4,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/5.png`,
    content: block5,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/6.png`,
    content: block6,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/7.png`,
    content: block7,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/9.png`,
    content: block9,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/11.png`,
    content: block11,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/12.png`,
    content: block12,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/13.png`,
    content: block13,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/15.png`,
    content: block15,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/17.png`,
    content: block17,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/18.png`,
    content: block18,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/19.png`,
    content: block19,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/21.png`,
    content: block21,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/24.png`,
    content: block24,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/25.png`,
    content: block25,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/26.png`,
    content: block26,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/27.png`,
    content: block27,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/28.png`,
    content: block28,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/29.png`,
    content: block29,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/30.png`,
    content: block30,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/31.png`,
    content: block31,
  },
  {
    image: `${process.env.TEMPLATES_BUCKET_URL}/blocks/text/mtg/32.png`,
    content: block32,
  },
];
